import { render } from "./FormSendButton.vue?vue&type=template&id=768aed4a"
import script from "./FormSendButton.vue?vue&type=script&lang=js"
export * from "./FormSendButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__